const state = {
    title: null,
    collapsed: false,
    detail: null, // 实体详情对象 {type: String, obj: entity}
    form: null, // 添加页默认的关联实体对象 {{key | 字段名 : entity | 实体对象}}
    routes: [], // 顶部面包屑路由数组
    menus: [],
    subMenus: null,
    defaultPath: null,
    user: null,
    vs: true // 是否显示切换乡村
};

// getters
const getters = {
    title: state => state.title,
    collapsed: state => state.collapsed,
    detail: state => state.detail,
    form: state => state.form,
    routes: state => state.routes,
    menus: state => state.menus,
    subMenus: state => state.subMenus,
    defaultPath: state => state.defaultPath,
    user: state => state.user,
    vs: state => state.vs,
};

// mutations
const mutations = {
    setTitle(state, title) {
        state.title = title;
    },
    changeVs(state, value) {
        state.vs = value;
    },
    changeCollapsed(state, collapsed) {
        state.collapsed = collapsed;
    },
    updateRoutes(state, value) {
        state.routes = value;
    },
    setMenus(state, value) {
        state.menus = value;
    },
    setSubMenus(state, value) {
        state.subMenus = value;
    },
    setDefaultPath(state, value) {
        state.defaultPath = value;
    },
    setDetail(state, value) {
        state.detail = value;
    },
    setForm(state, value) {
        state.form = value;
    },
    setUser(state, value) {
        state.user = value;
    },
};

const actions = {

};

export default {
    state,
    getters,
    mutations,
    actions
}
